import { useState, useEffect } from 'react';

/**
 * Custom hook for MQL Activity breakdown
 * Tracks MQL sources and their conversion to calls and clients
 */
export const useMQLActivity = (dateRange) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (isRefresh = false) => {
    if (isRefresh) {
      setRefreshing(true);
    } else {
      setLoading(true);
    }
    setError(null);

    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 800));

      // Mock data for MQL activities
      const mockData = {
        activities: [
          {
            name: 'ScaleMaps Completed',
            mqls: 45,
            callConversions: 12,
            clientConversions: 3,
            callConversionRate: 26.7,
            clientConversionRate: 6.7,
          },
          {
            name: 'Lead Magnet Downloaded',
            mqls: 78,
            callConversions: 18,
            clientConversions: 5,
            callConversionRate: 23.1,
            clientConversionRate: 6.4,
          },
          {
            name: 'AI Clone Yourself',
            mqls: 52,
            callConversions: 8,
            clientConversions: 2,
            callConversionRate: 15.4,
            clientConversionRate: 3.8,
          },
          {
            name: 'Webinar Registration',
            mqls: 34,
            callConversions: 11,
            clientConversions: 4,
            callConversionRate: 32.4,
            clientConversionRate: 11.8,
          },
          {
            name: 'Content Download',
            mqls: 62,
            callConversions: 9,
            clientConversions: 2,
            callConversionRate: 14.5,
            clientConversionRate: 3.2,
          },
        ],
        summary: {
          totalMQLs: 299,
          totalCallConversions: 73,
          totalClientConversions: 22,
          avgCallConversionRate: 24.4,
          avgClientConversionRate: 7.4,
        },
      };

      setData(mockData);
    } catch (err) {
      setError(err.message || 'Failed to fetch MQL activity data');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dateRange]);

  const refetch = () => fetchData(true);

  return {
    data,
    loading,
    refreshing,
    error,
    refetch,
  };
};